module.exports = __webpack_public_path__ + "static/media/voice.339c9107.png";